// src/components/ui/Input.js
import React from 'react';

export function Input({ 
  label, 
  error, 
  helperText, 
  className = '', 
  prefix,
  id,
  ...props 
}) {
  return (
    <div className={`space-y-1.5 ${className}`}>
      {label && (
        <label htmlFor={id} className="block text-sm font-bold text-gray-700">
          {label}
        </label>
      )}
      
      <div className="flex rounded-lg shadow-sm border border-gray-300 bg-white focus-within:border-primary focus-within:ring-4 focus-within:ring-primary/10 transition-all duration-200 overflow-hidden">
        {prefix && (
          <div className="flex items-center px-3 bg-gray-50 text-gray-500 text-sm border-r border-gray-300 whitespace-nowrap">
            {prefix}
          </div>
        )}
        
        <input
          id={id}
          className={`
            block w-full border-none bg-transparent py-2.5 px-3
            text-gray-900 placeholder-gray-400
            focus:ring-0 outline-none
            disabled:bg-gray-50 disabled:text-gray-500
            ${error ? 'text-red-600' : ''}
          `}
          {...props}
        />
      </div>

      {error ? (
        <p className="text-xs text-red-600 font-medium">{error}</p>
      ) : helperText ? (
        <p className="text-xs text-gray-500">{helperText}</p>
      ) : null}
    </div>
  );
}

export function TextArea({ label, error, helperText, className = '', id, ...props }) {
  return (
    <div className={`space-y-1.5 ${className}`}>
      {label && (
        <label htmlFor={id} className="block text-sm font-bold text-gray-700">
          {label}
        </label>
      )}
      
      <textarea
        id={id}
        className={`
          block w-full rounded-lg border border-gray-300 bg-white py-2.5 px-3
          text-gray-900 placeholder-gray-400
          transition-all duration-200
          focus:border-primary focus:ring-4 focus:ring-primary/10 outline-none
          disabled:bg-gray-50 disabled:text-gray-500
          ${error ? 'border-red-500 focus:border-red-500 focus:ring-red-500/10' : ''}
        `}
        {...props}
      />

      {error ? (
        <p className="text-xs text-red-600 font-medium">{error}</p>
      ) : helperText ? (
        <p className="text-xs text-gray-500">{helperText}</p>
      ) : null}
    </div>
  );
}
